import { useRef } from 'react';
import useCssProp from '~/hooks/useCssProp';
import isServerSideRendering from '~/utilities/IsServerSideRendering';

const useHideBottomDockModals = (shouldHide: boolean) => {
  const el = useRef<HTMLElement>(
    isServerSideRendering ? null : document.documentElement
  );

  useCssProp(el, '--filters-active', String(shouldHide ? 1 : 1250));
};

export default useHideBottomDockModals;
